import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { EvTooltipModule } from "ev-tooltip";
import { EvDirectivesModule } from "ev-directives";
import { EvCore } from "ev-core";
import { Router } from "@angular/router";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";

@Component({
    selector: "new-dwelling-cluster-map-marker",
    imports: [EvTooltipModule, EvDirectivesModule, EvCore],
    templateUrl: "./new-dwelling-cluster-map-marker.component.html",
    styleUrl: "./new-dwelling-cluster-map-marker.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingClusterMapMarkerComponent {
    private readonly router = inject(Router);
    readonly data = input<IProjectStageDto[]>([]);

    private readonly distinctProjectIds = computed(() => Array.from(new Set(this.data().map((p) => p.projectId))));

    protected numberOfProjects = computed(() => Math.min(99, this.distinctProjectIds().length));

    protected projectNameOrGeneralText = computed(() =>
        this.distinctProjectIds().length === 1 ? this.data()[0].projectName : "Ulike prosjekter"
    );

    showSale(sale: IProjectStageDto) {
        const navigationParams = { queryParams: { pid: sale.projectId } };
        this.router.navigate(["/infopage/newdwelling/project"], navigationParams);
    }
}
